import { Track } from '../types/audio'
import { sampleTracks } from '../data/sampleTracks'
import './PlaylistView.css'

interface PlaylistViewProps {
  onTrackSelect: (track: Track) => void
  currentTrack: Track | null
}

export function PlaylistView({ onTrackSelect, currentTrack }: PlaylistViewProps) {
  return (
    <div className="playlist-view">
      <h2>Your Playlist</h2>
      <div className="playlist-header">
        <div className="track-number">#</div>
        <div className="track-title">Title</div>
        <div className="track-artist">Artist</div>
        <div className="track-duration">Duration</div>
      </div>
      <div className="tracks-list">
        {sampleTracks.map((track, index) => (
          <div
            key={track.id}
            className={`track-item ${currentTrack?.id === track.id ? 'active' : ''}`}
            onClick={() => onTrackSelect(track)}
          >
            <div className="track-number">{index + 1}</div>
            <div className="track-info">
              <div className="track-title">{track.title}</div>
              {track.coverArt && (
                <img 
                  src={track.coverArt} 
                  alt={`${track.title} cover`} 
                  className="track-cover"
                />
              )}
            </div>
            <div className="track-artist">{track.artist}</div>
            <div className="track-duration">{track.duration}</div>
          </div>
        ))}
      </div>
    </div>
  )
} 